// extracted by mini-css-extract-plugin
export default {"appContainer":"style_appContainer__RvM3c"};